import { render, staticRenderFns } from "./TabContent.vue?vue&type=template&id=261ff60f&"
import script from "./TabContent.vue?vue&type=script&lang=ts&"
export * from "./TabContent.vue?vue&type=script&lang=ts&"
import style0 from "./TabContent.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports